"use client";

import { useEffect, useRef, useState } from "react";
import ChevronDown from "@/components/icons/chevron-down";

export const CategoryBarScroller = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const update = () => {
    const el = ref.current;
    if (!el) {
      return;
    }
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: //todo
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    update();
    el.addEventListener("scroll", update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      el.removeEventListener("scroll", update);
      ro.disconnect();
    };
  }, []);

  return (
    <div className="relative">
      {canScrollLeft && (
        <>
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-linear-to-r from-white to-transparent" />
          <button
            aria-label="Sola kaydır"
            className="absolute inset-y-0 left-0 z-20 flex items-center px-1 cursor-pointer hover:bg-brand-blue-100 rounded-lg"
            onClick={() =>
              ref.current?.scrollBy({ behavior: "smooth", left: -200 })
            }
            type="button"
          >
            <ChevronDown className="rotate-90 stroke-neutral-500 fill-none" />
          </button>
        </>
      )}

      <div
        className="flex flex-row flex-nowrap items-center gap-3 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        ref={ref}
      >
        {children}
      </div>

      {canScrollRight && (
        <>
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-linear-to-l from-white to-transparent" />
          <button
            aria-label="Sağa kaydır"
            className="absolute inset-y-0 right-0 z-20 flex items-center px-1 hover:cursor-pointer hover:bg-brand-blue-100 rounded-lg"
            onClick={() =>
              ref.current?.scrollBy({ behavior: "smooth", left: 200 })
            }
            type="button"
          >
            <ChevronDown className="-rotate-90 stroke-neutral-500 fill-none" />
          </button>
        </>
      )}
    </div>
  );
};
